<!--footer section -->
<footer class="footer-light">
	<div class="footer-top col-md-12">
		<img class="separador" src="/assets/images/footer/distrimay-footer-top.png" width="100%">
	   </div>

	   <div class="footer row">
		<div class="col-md-8 logo-ft">
			<img class="separador" src="/assets/images/logos/logo-distrimay.png">
			<ul>
				<li>Av. Cárcano 732 - <strong>Villa Carlos Paz</strong></li>
				<li>Av. Pablo Ricchieri 3055 - <strong>Cba. Capital</strong></li>
				<li>Pedro Goyena 252 - <strong>Cba. Capital</strong></li>
			</ul>
		</div>

		<div class="seguinos col-md-4">

		  <img src="/assets/images/footer/distrimay-seguinos.png" width="200px">
		  <br>

		  <a href="https://www.facebook.com/distribuidoradistrimay"><i class="fa fa-facebook"></i></a>
		 <a href="https://www.instagram.com/distri_may/?hl=es"> <i class="fa fa-instagram"></i></a>
		 <a href="https://www.tiktok.com/@distrimay"><svg xmlns="http://www.w3.org/2000/svg" height="10" width="8.75" viewBox="0 0 448 512"><path fill="#b0ca13" d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"/></svg></a>

		</div>


	   </div>

	   <div class="footer-bottom col-md-12">
		<p class="vrd"><i _ngcontent-ken-c5="" aria-hidden="true" class="fa fa-copyright"></i> 2023 powered by BuhoManager - v. {{version}}</p>
	   </div>

</footer>
<!--footer section end -->
